import { memo } from 'react';

import { CircleQuestionMarkIcon } from '@air/design-icons';
import { DropdownMenu } from '@air/primitive-dropdown-menu';

import { HelpDropdownMenuItems } from '~/components/HelpDropdownMenuItems';
import {
  MAIN_SIDE_NAV_SMALL_ICON_SIZE,
  MainSideNavItemButton,
} from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItemButton';
import { MainSideNavItemIcon } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItemIcon';
import { MainSideNavItemLabel } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItemLabel';
import { useMainSideNavOverlay } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavOverlay';

export const MainSideNavItemHelp = memo(() => {
  const { isOpen, onOpenChange } = useMainSideNavOverlay({ id: 'help' });

  return (
    <DropdownMenu
      align="start"
      onOpenChange={onOpenChange}
      open={isOpen}
      side="right"
      trigger={
        <MainSideNavItemButton data-item-id="help" data-main-side-nav-overlay type="button">
          <MainSideNavItemIcon>
            <CircleQuestionMarkIcon className="shrink-0" size={MAIN_SIDE_NAV_SMALL_ICON_SIZE} />
          </MainSideNavItemIcon>
          <MainSideNavItemLabel>Help and Support</MainSideNavItemLabel>
        </MainSideNavItemButton>
      }
    >
      <HelpDropdownMenuItems />
    </DropdownMenu>
  );
});

MainSideNavItemHelp.displayName = 'MainSideNavItemHelp';
